import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    backgroundColor: theme.palette.yellow,
    border: "none",
    boxShadow: "none",
    margin: "0 auto",
    paddingBottom: "2.5rem",
    maxWidth: "21.4rem",
    [theme.breakpoints.up('md')]: {
      maxWidth: "53.5rem"
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    padding: "0",
    maxWidth: "53.5rem",
    "&:last-child": {
      paddingBottom: 0
    },
    [theme.breakpoints.up('lg')]: {
      flexDirection: "row",
    },
  },
  imageLeft: {
    flexDirection: "column-reverse",
    '& $description': {
      padding: "2.5rem 0 0 0"
    },
    [theme.breakpoints.up('lg')]: {
      flexDirection: "row-reverse",
      '& $description': {
        padding: "0 0 0 2rem"
      }
    },
  },
  description: {
    height: "100%",
    margin: "0 auto",
    padding: "0 0 2.5rem 0",
    boxSizing: "content-box",
    '& p': {
      fontFamily: 'Roboto',
      height: "auto",
      fontSize: "1rem"
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: "45rem",
    },
    [theme.breakpoints.up('lg')]: {
      padding: "0 2rem 0 0",
      margin: "auto 0",
      maxWidth: "25.75rem",
      '& p': {
        fontSize: "1.25rem",
      },
    },
  }
}));
